import { Component, OnInit, Inject } from '@angular/core';
import {animate, style, transition, trigger} from "@angular/animations";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";

/**
 * Parameters for DeleteThresholdConfirmDialogComponent
 */
export interface DeleteThresholdConfirmDialogData {
  transitTime: string;
  threshold: string;
  cronDescriptor: string;
  componentKeyValue: string;
}

@Component({
  selector: 'app-delete-threshold-confirm-dialog',
  templateUrl: './delete-threshold-confirm-dialog.component.html',
  styleUrls: ['./delete-threshold-confirm-dialog.component.scss'],
  animations: [
    trigger('dialog', [
      transition('void => *', [
        style({transform: 'scale3d(.3, .3, .3)'}),
        animate(100)
      ]),
      transition('* => void', [
        animate(100, style({transform: 'scale3d(.0, .0, .0)'}))
      ])
    ])
  ]
})
export class DeleteThresholdConfirmDialogComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DeleteThresholdConfirmDialogData
  ) { }

  ngOnInit(): void {
  }
}
